// @see mylw-lwprod.nexcess-internal.workers.dev
import prodTemplate from './prod';
import type { AppConfigI } from './example';

const lwprod: AppConfigI = prodTemplate;

export default lwprod;
